import React from 'react';
import { Link } from 'react-router-dom';

export default function Settings() {
  return (
    <div className="w-full max-w-md p-6 mx-auto bg-white shadow-lg animate-fade-in md:max-w-2xl md:p-8 rounded-2xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-red-600">
          Settings
        </h2>
      </div>

      <div className="space-y-3">
        <Link
          to="/profile"
          className="flex items-center p-4 text-gray-700 transition-colors rounded-lg bg-gray-50 hover:bg-red-50 hover:text-red-600"
        >
          <span className="mr-4 text-xl">👤</span>
          <span className="text-lg font-medium">Profile</span>
          <span className="ml-auto text-gray-400">→</span>
        </Link>

        <Link
          to="/contact-annam"
          className="flex items-center p-4 text-gray-700 transition-colors rounded-lg bg-gray-50 hover:bg-red-50 hover:text-red-600"
        >
          <span className="mr-4 text-xl">📞</span>
          <span className="text-lg font-medium">Contact Annam</span>
          <span className="ml-auto text-gray-400">→</span>
        </Link>

        <Link
          to="/help"
          className="flex items-center p-4 text-gray-700 transition-colors rounded-lg bg-gray-50 hover:bg-red-50 hover:text-red-600"
        >
          <span className="mr-4 text-xl">📚</span>
          <span className="text-lg font-medium">Terms & Help</span>
          <span className="ml-auto text-gray-400">→</span>
        </Link>
      </div>
    </div>
  );
}
